import { render, staticRenderFns } from "./comment.vue?vue&type=template&id=7b1ea9ed&scoped=true&"
import script from "./comment.vue?vue&type=script&lang=js&"
export * from "./comment.vue?vue&type=script&lang=js&"
import style0 from "./comment.vue?vue&type=style&index=0&id=7b1ea9ed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b1ea9ed",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/xinyu/.jenkins/workspace/vue-Commonality-CMS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b1ea9ed')) {
      api.createRecord('7b1ea9ed', component.options)
    } else {
      api.reload('7b1ea9ed', component.options)
    }
    module.hot.accept("./comment.vue?vue&type=template&id=7b1ea9ed&scoped=true&", function () {
      api.rerender('7b1ea9ed', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "oxygen/cms/components/common/comment.vue"
export default component.exports